/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/14/2016
 * Copyright All Rights Reserved
 */

/**
 * App requests token from server
 * @type {string}
 */
export const REQUEST_TOKEN = 'REQUEST_TOKEN';

/**
 * App receives token from server in response to token request
 * @type {string}
 */
export const REQUEST_TOKEN_SUCCESS = 'REQUEST_TOKEN_SUCCESS';

/**
 * App receives error from server in response to token request
 * @type {string}
 */
export const REQUEST_TOKEN_FAILURE = 'REQUEST_TOKEN_FAILURE';

/**
 * Destroy the token
 *
 * @type {string}
 */
export const DESTROY_TOKEN = 'DESTROY_TOKEN';

/**
 * App attempts to create a new site on the server
 * @type {string}
 */
export const REQUEST_CREATE_SITE = 'REQUEST_CREATE_SITE';

/**
 * App receives response from server indicating successful site creation
 * @type {string}
 */
export const REQUEST_CREATE_SITE_SUCCESS = 'REQUEST_CREATE_SITE_SUCCESS';

/**
 * App receive error from server in response to attempt to create a new site
 * @type {string}
 */
export const REQUEST_CREATE_SITE_FAILURE = 'REQUEST_CREATE_SITE_FAILURE';

/**
 * App requests the list of reports from the server
 * @type {string}
 */
export const REQUEST_FETCH_REPORTS = 'REQUEST_FETCH_REPORTS';

/**
 * App successfully receives the list of reports from the server
 * @type {string}
 */
export const REQUEST_FETCH_REPORTS_SUCCESS = 'REQUEST_FETCH_REPORTS_SUCCESS';

/**
 * App receives error from server in response to a request for the list of reports
 * @type {string}
 */
export const REQUEST_FETCH_REPORTS_FAILURE = 'REQUEST_FETCH_REPORTS_FAILURE';
